import React from "react";
import "./style.css";
import emailForwardIcon from "../../images/icons/send-mail-icon.jpg";

export default function ShareLinks({
  toggleMailShareForm = () => {},
  location,
  disableMailShare = false,
}) {
  // console.log("location: ", location);
  return (
    <div className="headsocialLink">
      <div
        className="headsocialLink__sharee"
        style={{ color: "#22316B !important" }}
      >
        SHARE
      </div>
      <span className="hicon">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
          target="_blank"
          className=""
          style={{ display: "block !important" }}
          title="Share on Facebook"
        >
          <img
            src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
            alt=""
          />
        </a>
      </span>
      <span className="hicon">
        <a
          style={{ display: "block !important" }}
          href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
          target="_blank"
          className=""
          title="Share on Twitter"
        >
          <img
            src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
            alt=""
          />
        </a>
      </span>
      <span className="hicon">
        <a
          style={{ display: "block !important" }}
          href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
          target="_blank"
          className=""
          title="Share on LinkedIn"
        >
          <img
            src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
            alt=""
          />
        </a>
      </span>
      {!disableMailShare && (
        <span className="hicon">
          <button
            style={{ display: "block !important" }}
            className="forwardMail"
            title="Forward to email"
            onClick={toggleMailShareForm}
          >
            <img src={emailForwardIcon} alt="" />
          </button>
        </span>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/newsletterShareLinks/index.js